<template>
    <div class="curr-user">
        <span class="fw400">{{user.email}} / </span>
        <a href="#" @click="logout">выйти</a>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'user',
            ])
        },
        methods:{
            logout(){
                this.$store.dispatch('logout');
            },
        }
    }
</script>
